import request from '@/utils/request'

export const getEmailConfirmationInfo = (customerId: string) =>
  request({
    url: `/market/v1/customers/${customerId}/email_status?subject=confirmation`,
    method: 'get'
  })

export const approvementCheck = (customerId: string) =>
  request({
    url: `/market/v1/customers/${customerId}/approvement_check`,
    method: 'post'
  })

export const updateCustomerProgram = (customerId: string, programId: string) =>
  request({
    url: `/market/v1/customers/${customerId}`,
    method: 'patch',
    data: {
      data: {
        type: 'customers',
        id: customerId,
        attributes: {
          program_id: programId
        }
      }
    }
  })

export const importCustomers = (signedId: string, programId: string) =>
  request({
    url: '/market/v1/customers/import',
    method: 'put',
    timeout: 60000,
    data: {
      data: {
        type: 'customers',
        blob: signedId,
        program_id: programId
      }
    }
  })
